function DownloadReport() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <g clipPath="url(#clip0_download_report)">
                <path d="M15.3332 12.1453V13.4206C15.333 13.9278 15.1314 14.4142 14.7728 14.7729C14.4141 15.1315 13.9277 15.3331 13.4205 15.3333H2.57917C2.0719 15.3333 1.58541 15.1318 1.22671 14.7731C0.868016 14.4144 0.666504 13.9279 0.666504 13.4206V12.1453" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M8 12.0721V0.666748" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M12.6668 7.40527L8.00016 12.0719L3.3335 7.40527" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
            </g>
            <defs>
                <clipPath id="clip0_download_report">
                    <rect width="16" height="16" fill="white"/>
                </clipPath>
            </defs>
        </svg>
    );
}

export default DownloadReport;
